export default {
  data() {
    return {
      isMsgInitialVisible: false,
    }
  },
  methods: {
    observeMsgEl(msgEl) { //call on mounted, pass an elemment
      const options = {
        root: msgEl.closest('.chat-container'),
        threshold: 0,
      }

      const msgWithImgObserver = new IntersectionObserver(this.isComponentVisibleInitial, options);
      msgWithImgObserver.observe(msgEl.parentElement);
    },
    isComponentVisibleInitial([entry], observer) {
      // intersectionRatio value between 0.0 and 1.0
      // 1 - element fully visible
      if (entry.intersectionRatio === 1) {
        this.isMsgInitialVisible = true;
      }

      //stops observing element's position after observing their initial position (once mounted), it will not observe element's new position when scrolling started
      observer.disconnect();
    },
  },
}
